import type { FieldType } from '#types/System.types';
import { resolveTrackingUrlForShippingValue } from '@/components/rendering/fields/ShippingTrackerUI/resolveTrackingUrlForShippingValue';
import { isShippingTrackerFieldTypeId } from '@/components/rendering/fields/ShippingTrackerUI/isShippingTrackerFieldTypeId';
import { COMPOSITE_FIELD_EMPTY_PLACEHOLDER } from './compositeFieldPlaceholders';
import type { FormattedValueParts } from './formatPreviewValue';
import type { FormattedCellValue } from './formattedCellValue';

export function appendShippingTrackingUrlToFormattedValueParts(
  parts: FormattedValueParts,
  value: unknown,
  fieldType: FieldType,
): FormattedValueParts {
  if (!isShippingTrackerFieldTypeId(fieldType.fieldDataTypeId)) {
    return parts;
  }
  const url = resolveTrackingUrlForShippingValue(value);
  if (!url) return parts;
  const base = resolveShippingDisplayText(value, parts.formatted);
  const nextFormatted: FormattedCellValue = { display: base, url };
  return { ...parts, formatted: nextFormatted };
}

function resolveShippingDisplayText(value: unknown, formatted: FormattedCellValue): string {
  if (typeof formatted === 'object') return formatted.display;
  if (formatted && formatted !== COMPOSITE_FIELD_EMPTY_PLACEHOLDER) return formatted;
  if (typeof value === 'string') return value.trim();
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const trackingNumber = (value as { components?: { trackingNumber?: unknown } }).components?.trackingNumber;
    if (typeof trackingNumber === 'string' && trackingNumber.trim()) return trackingNumber.trim();
  }
  return '';
}
